import React from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import amex from "@assets/icons/american-express.svg";
import mastercard from "@assets/icons/mastercard.svg";
import paypal from "@assets/icons/paypalRec.svg";
import visa from "@assets/icons/visa.svg";
import Helpers from "@utils/Helpers";
import {
  CONTACT_EMAIL,
  FooterLink,
  FOOTER_GROUPS,
  LEGAL_LINKS,
} from "./footerLinks";

const renderLink = (link: FooterLink) => {
  if (link.to) {
    return <Link to={link.to}>{link.label}</Link>;
  }
  if (link.href) {
    return <a href={link.href}>{link.label}</a>;
  }
  return <span>{link.label}</span>;
};

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  const version = process.env.REACT_APP_FRONTEND_LATEST_TAG;
  const logo = Helpers.getImageFrontPage("logo");

  return (
    <footer className="footer-section">
      <div className="cta-banner">
        <div className="container cta-inner">
          <div className="cta-block cta-left">
            <div className="cta-text">
              <h2 className="cta-title">Looking for hay?</h2>
              <p className="cta-subtitle">
                Browse listings from verified producers and place a bid.
              </p>
            </div>
            <Link className="cta-button cta-button-light" to="/products">
              Browse catalog
            </Link>
          </div>
          <div className="cta-divider" />
          <div className="cta-block cta-right">
            <div className="cta-text">
              <h2 className="cta-title">Selling hay?</h2>
              <p className="cta-subtitle">
                List your product and reach buyers across the region.
              </p>
            </div>
            <Link
              className="cta-button cta-button-orange"
              to="/product/register"
            >
              Start selling
            </Link>
          </div>
        </div>
      </div>

      <div className="container footer-main">
        <div className="footer-grid">
          <div className="footer-brand">
            {logo && (
              <span className="footer-logo">
                <img src={logo} alt="Hay2U" height="44" />
              </span>
            )}
            <p className="footer-tagline">
              The online marketplace where hay producers and buyers trade
              directly.
            </p>
            <a className="footer-email" href={`mailto:${CONTACT_EMAIL}`}>
              {CONTACT_EMAIL}
            </a>
          </div>
          {FOOTER_GROUPS.map((group) => (
            <nav key={group.title} aria-label={group.title}>
              <h2 className="menu-title">{group.title}</h2>
              <ul className="menu-list">
                {group.links.map((link) => (
                  <li key={link.label} className="menu-item">
                    {renderLink(link)}
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <div className="bottom-block">
          <div className="payment-trust">
            <ul className="payment-icons" aria-label="Accepted payment methods">
              <li className="payment-badge">
                <img src={visa} alt="Visa" />
              </li>
              <li className="payment-badge">
                <img src={mastercard} alt="Mastercard" />
              </li>
              <li className="payment-badge payment-badge-wordmark">
                <img src={amex} alt="American Express" />
              </li>
              <li className="payment-badge">
                <img src={paypal} alt="PayPal" />
              </li>
            </ul>
            <div className="trust-badge">
              <svg
                className="trust-icon"
                viewBox="0 0 24 24"
                width="17"
                height="17"
                aria-hidden="true"
              >
                <path
                  d="M12 3l7 2.5v5.7c0 4.3-2.9 7.9-7 9.3-4.1-1.4-7-5-7-9.3V5.5L12 3z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 12l2 2 4-4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Secure checkout. Prices in CAD.</span>
            </div>
          </div>

          <div className="copy-right">
            <div className="copy-right-group">
              <div className="Reserved">
                © {year} Hay2U. All rights reserved.
                {version ? ` ${version}` : null}
              </div>
              <nav className="term" aria-label="Legal">
                <ul className="legal-list">
                  {LEGAL_LINKS.map((link) => (
                    <li key={link.label}>{renderLink(link)}</li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
